import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useResize } from '../../hooks'
import { Text } from '../'
import { COLOR, IconVisit } from '../../assets'
import {
  Container,
  ImageContainer,
  TitleContainer,
  DescriptionContainer,
  ArrowLeft,
  ImageIcon360Container,
  Text360
} from './index.styled'


const CardFactoryStartVisit = React.memo(({ 
  image, type = 'multiline', action = () => {}, title = "card-factory-showroom.title", 
  description = "card-factory-showroom.description", titleWithoutTranslate = false
}) => {

  const [elementWidth, setElementWidth ] = useState(0);

  const widthScreen = useResize().width;
  const ref = useRef(null);

  useEffect(() => {
    setElementWidth(ref?.current.offsetWidth)
  }, [widthScreen])
  return (
    <Container onClick={action}>
      <Text360 className="text-enter">enter 360° tour</Text360>
      <ImageIcon360Container mask={IconVisit} className="image-icon"/>
      <ImageContainer className="image" src={image} />
      <TitleContainer ref={ref} width={elementWidth}>
          <Text
            color={COLOR.quinary}
            className="title title-component"
            textId={title}
            titleWithoutTranslate={titleWithoutTranslate}
          />
          <ArrowLeft className="arrow"/>
      </TitleContainer>
      <DescriptionContainer>
          <Text
            color={COLOR.quinary}
            className="description description-component"
            typeDescription={type}
            fontFamily="Amorim Sans Book"
            textId={description || null}
            fontSize='14px'
          />
      </DescriptionContainer>
    </Container>
  )
})

CardFactoryStartVisit.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string
}

export default React.memo(CardFactoryStartVisit)
